import { API } from '..';

// Nhật ký hành động admin (audit). Backend: cab-user-service, controller AuditAdmin → route admin/Audit
// (route case-insensitive). Route admin qua gateway (Role Admin/Mod).
const BASE = '/v1/user-service/admin/audit';

export interface AuditLog {
  id: string;
  actorId: string;
  actorName: string;
  action: string;
  targetType: string;
  targetId: string;
  detail: string;
  createdAt: string;
}

export interface AuditLogPage {
  total: number;
  pageNumber: number;
  pageSize: number;
  items: AuditLog[];
}

export interface AuditQuery {
  pageNumber?: number;
  pageSize?: number;
  action?: string;
  actorId?: string;
  from?: string;
  to?: string;
}

export const getAuditLogs = (params: AuditQuery) =>
  API.get<AuditLogPage>(`${BASE}/logs`, { params }).then((r) => r.data);

export const getAuditActions = () =>
  API.get<string[]>(`${BASE}/actions`).then((r) => r.data);
